<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<el-form :inline="true" :model="formInline" class="user-search">
				<el-form-item label="所属门店：">
					<el-select v-model="formInline.storeKeyId" placeholder="请选择门店" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="员工：">
					<el-select v-model="formInline.userKeyId" placeholder="请选择人员" clearable filterable size="small" @change="inputChange">
						<el-option v-for="item in userList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="日期：">
					<el-date-picker v-model="dateStr" type="month" value-format="yyyy-MM" format="yyyy年MM月" size="small" :clearable="false" @change="handleDateChange"></el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button v-if="$checkBtnPermission('/monthSalary/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
					<el-button v-if="$checkBtnPermission('/monthSalary/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEdit()">新增</el-button>
					<el-button v-if="$checkBtnPermission('/monthSalary/index', 'export')" size="small" type="warning" class="el-icon-s-promotion" @click="handleExport()" :loading="exportLoading">导出</el-button>
					<el-button v-if="$checkBtnPermission('/monthSalary/index', 'generate')" size="small" type="success" class="el-icon-date" @click="handleGenerate()">生成工资</el-button>
					<el-button v-if="$checkBtnPermission('/monthSalary/index', 'updateBaseSalary')" size="small" type="primary" plain class="el-icon-refresh" @click="handleBatchRefresh(1)">批量刷新基本工资</el-button>
					<el-button v-if="$checkBtnPermission('/monthSalary/index', 'updateBonus')" size="small" type="warning" plain class="el-icon-refresh" @click="handleBatchRefresh(2)">批量刷新提成</el-button>
				</el-form-item>
			</el-form>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId" height="600px" @row-db-click="handleEdit">
				<!-- 年月（链接到详情） -->
				<template #yearMonth>
					<el-table-column align="center" label="年月" min-width="120">
						<template #default="scope">
							<el-link type="primary" :underline="false" @click="handleShowDetail(scope.row)">{{ scope.row.year }}年{{ scope.row.month }}月</el-link>
						</template>
					</el-table-column>
				</template>
				<!-- 入职时间 -->
				<template #entryTime>
					<el-table-column align="center" label="入职时间" width="120">
						<template #default="scope">
							{{ scope.row.userInfo && scope.row.userInfo.createTime ? scope.row.userInfo.createTime.substring(0, 10) : '' }}
						</template>
					</el-table-column>
				</template>
				<!-- 是否确认 -->
				<template #isConfirm>
					<el-table-column align="center" label="是否确认" width="100">
						<template #default="scope">
							<el-tag v-if="scope.row.isConfirm === 1" type="success">是</el-tag>
							<el-tag v-else type="danger">否</el-tag>
						</template>
					</el-table-column>
				</template>
			<!-- 应发基本工资（计算列） -->
			<template #shouldPayBaseSalary>
				<el-table-column align="center" label="应发基本工资" width="100">
					<template #default="scope">
						{{ money2(scope.row.baseSalary + scope.row.perfectAttendance) }}
					</template>
				</el-table-column>
			</template>
			<!-- 充卡提成（链接到提成记录） -->
			<template #cardBonus>
				<el-table-column align="center" label="充卡提成" width="90">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 1)">{{ money2(scope.row.cardBonus) }}</el-link>
					</template>
				</el-table-column>
			</template>
			<!-- 销售提成 -->
			<template #notCardBonus>
				<el-table-column align="center" label="销售提成" width="90">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 2)">{{ money2(scope.row.notCardBonus) }}</el-link>
					</template>
				</el-table-column>
			</template>
			<!-- 电话提成 -->
			<template #phoneBonus>
				<el-table-column align="center" label="电话提成" title="电话提成(销售20%部分)" width="90">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 3)">{{ money2(scope.row.phoneBonus) }}</el-link>
					</template>
				</el-table-column>
			</template>
			<!-- 跑单提成 -->
			<template #paoDanBonus>
				<el-table-column align="center" label="跑单提成" width="90">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 4)">{{ money2(scope.row.paoDanBonus) }}</el-link>
					</template>
				</el-table-column>
			</template>
			<!-- 进店成交提成 -->
			<template #chengJiaoBonus>
				<el-table-column align="center" label="进店成交提成" width="100">
					<template #default="scope">
						<el-link type="primary" :underline="false" @click="handleShowCommissionList(scope.row, 5)">{{ money2(scope.row.chengJiaoBonus) }}</el-link>
					</template>
				</el-table-column>
			</template>
			<!-- 提成合计（计算列） -->
			<template #bonusTotal>
				<el-table-column align="center" label="提成合计" width="90">
					<template #default="scope">
						{{ money2(scope.row.notCardBonus + scope.row.cardBonus + scope.row.phoneBonus + scope.row.schoolBonus + scope.row.paoDanBonus + scope.row.chengJiaoBonus) }}
					</template>
				</el-table-column>
			</template>
				<!-- 操作列 -->
				<template #operation>
					<el-table-column v-if="btnPermission.confirm || btnPermission.updateBaseSalary || btnPermission.updateBonus || btnPermission.delete" align="center" label="操作" width="360" fixed="right">
						<template #default="scope">
							<el-button v-if="scope.row.isConfirm === false && btnPermission.confirm" size="mini" type="primary" class="el-icon-check" @click="handleConfirm(scope.row)">确认</el-button>
							<el-button v-if="scope.row.isConfirm === false && btnPermission.updateBaseSalary" size="mini" type="primary" class="el-icon-refresh" @click="handleUpdateBaseSalary(scope.row)">基本工资</el-button>
							<el-button v-if="scope.row.isConfirm === false && btnPermission.updateBonus" size="mini" type="warning" class="el-icon-refresh" @click="handleUpdateBonus(scope.row)">提成</el-button>
							<el-button v-if="scope.row.isConfirm === false && btnPermission.delete" size="mini" type="danger" class="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑界面 -->
		<edit ref="edit"></edit>
		<!-- 详情界面 -->
		<detail ref="detail"></detail>
		<!-- 提成记录弹窗 -->
		<commissionRecord ref="commissionRecord"></commissionRecord>
		<exportBlockDialog :visible.sync="exportBlockVisible" :title="exportBlockTitle" :blocks="exportBlockData" />
	</div>
</template>

<script>
import { GetUserMonthSalaryPageList, ExportUserMonthSalary, ConfirmUserMonthBaseSalary, UpdateUserMonthBonus, UpdateUserMonthBaseSalary, DeleteUserMonthSalary, GenerateUserMonthSalary, BatchRefreshUserMonthSalary } from "@/api/salaryApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import { GetUserBindSelectByPermission } from "@/api/userApi.js";
import { exportWithLoading } from "@/api/exportFile";
import exportBlockDialog from "@/components/exportBlockDialog.vue";
import edit from "@/views/accounting/salary/monthSalary/edit.vue";
import detail from "@/views/accounting/salary/monthSalary/detail.vue";
import commissionRecord from "@/views/accounting/storeCost/commission/recordDialog.vue";

// 金额统一保留两位小数（el-table 原生 formatter 签名：row, column, cellValue，供 prop 列 v-bind 使用）
const fmtMoney = (row, column, cellValue) => {
	const num = Number(cellValue);
	return isNaN(num) ? "0.00" : num.toFixed(2);
};

export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "员工月度工资"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			exportLoading: false, // 导出按钮 loading
			listData: [],
			selectionList: [],
			dateStr: new Date().getFullYear() + "-" + (new Date().getMonth() + 1),
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 15,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 15,
				storeKeyId: "",
				userKeyId: "",
				year: new Date().getFullYear(),
				month: new Date().getMonth() + 1
			},
			storeList: [],
			userList: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "60",
					isKeep: true
				},
				{
					prop: "storeName",
					label: "门店名称",
					isKeep: true,
					width: "100",
					align: "center",
				},
				{
					slot: "yearMonth",
					label: "年月",
					isKeep: true,
					minWidth: "120",
					align: "center",
				},
				{
					prop: "userInfo.chName",
					label: "员工",
					width: "100",
					align: "center",
					formatter: (row) => (row.userInfo ? row.userInfo.chName : "")
				},
				{
					slot: "entryTime",
					label: "入职时间",
					width: "120",
					align: "center",
				},
				{
					slot: "isConfirm",
					label: "是否确认",
					width: "100",
					align: "center",
				},
				{
					multi: true,
					label: "基础工资",
					align: "center",
					children: [
						{ prop: "baseSalary", label: "基础薪资", width: "90", align: "center", formatter: fmtMoney },
						{ prop: "perfectAttendance", label: "全勤", width: "80", align: "center", formatter: fmtMoney },
						{ slot: "shouldPayBaseSalary", label: "应发基本工资", width: "80", align: "center" },
						{ prop: "postWage", label: "岗位薪资", width: "90", align: "center", formatter: fmtMoney },
						{ prop: "socialSecuritySubsidy", label: "社保补贴", width: "90", align: "center", formatter: fmtMoney }
					]
				},
				{
					multi: true,
					label: "提成",
					align: "center",
					children: [
						{ slot: "cardBonus", label: "充卡提成", width: "90", align: "center" },
						{ slot: "notCardBonus", label: "销售提成", width: "90", align: "center" },
						{ slot: "phoneBonus", label: "电话提成(销售20%部分)", width: "90", align: "center" },
						{ slot: "paoDanBonus", label: "跑单提成", width: "90", align: "center" },
						{ slot: "chengJiaoBonus", label: "进店成交提成", width: "90", align: "center" },
						{ prop: "schoolBonus", label: "学校提成", width: "90", align: "center", formatter: fmtMoney },
						{ slot: "bonusTotal", label: "提成合计", width: "90", align: "center" }
					]
				},
				{
					multi: true,
					label: "其他",
					align: "center",
					children: [
						{ prop: "subtractMoney", label: "应扣除金额", width: "100", align: "center", formatter: fmtMoney },
						{ prop: "seniorityPay", label: "工龄", width: "80", align: "center", formatter: fmtMoney },
						{ prop: "finishedMoney", label: "目标达成奖励", width: "100", align: "center", formatter: fmtMoney },
						{ prop: "reissueMoney", label: "应补发金额", width: "100", align: "center", formatter: fmtMoney },
						{ prop: "salesIncreasing", label: "销售递增奖励", width: "100", align: "center", formatter: fmtMoney }
					]
				},
				{
					prop: "realMoeny",
					label: "实发总计",
					width: "90",
					align: "center",
					formatter: fmtMoney
				},
				{
					prop: "remark",
					label: "备注",
					width: "150",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "90",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "180",
					align: "center"
				},
				{
					prop: "confirmUserName",
					label: "确认人",
					width: "90",
					align: "center"
				},
				{
					prop: "confirmTime",
					label: "确认时间",
					width: "180",
					align: "center"
				},
				{
					slot: "operation",
					label: "操作",
					width: "360",
					align: "center",
					fixed: "right"
				}
			],
			btnPermission: {
				confirm: false,
				updateBaseSalary: false,
				updateBonus: false,
				delete: false,
				generate: false
			},
			exportBlockVisible: false,
			exportBlockTitle: "",
			exportBlockData: []
		};
	},
	// 注册组件
	components: {
		edit,
		detail,
		commissionRecord,
		exportBlockDialog
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		// 按钮权限（操作列用）
		this.btnPermission.confirm = this.$checkBtnPermission("/monthSalary/index", "confirm");
		this.btnPermission.updateBaseSalary = this.$checkBtnPermission("/monthSalary/index", "updateBaseSalary");
		this.btnPermission.updateBonus = this.$checkBtnPermission("/monthSalary/index", "updateBonus");
		this.btnPermission.delete = this.$checkBtnPermission("/monthSalary/index", "delete");
		this.btnPermission.generate = this.$checkBtnPermission("/monthSalary/index", "generate");
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.GetUserBindSelectByPermission();
	},
	computed: {},
	methods: {
		// 金额统一保留两位小数（slot 列模板内使用）
		money2(val) {
			const num = Number(val);
			return isNaN(num) ? "0.00" : num.toFixed(2);
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						res.data.forEach((item) => {
							this.storeList.push({
								keyId: item.keyId,
								value: item.name + "【" + item.remark2 + "】"
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 获取人员信息绑定下拉框_根据权限
		GetUserBindSelectByPermission() {
			const paramer = {};
			GetUserBindSelectByPermission(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.userList = [];
						this.userList = res.data;
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取人员信息失败!");
				});
		},
		// 获取列表
		getListData() {
			this.loading = true;
			GetUserMonthSalaryPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.loading = false;
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 日期选择器事件
		handleDateChange(val) {
			if (val.length > 0) {
				var list = val.split("-");
				this.formInline.year = parseInt(list[0]);
				this.formInline.month = parseInt(list[1]);
			} else {
				this.formInline.year = new Date().getFullYear();
				this.formInline.month = new Date().getMonth() + 1;
			}
			this.getListData();
		},
		// 新增/编辑
		handleEdit(row) {
			this.$refs.edit.editShow(row);
		},
		// 详情
		handleShowDetail(row) {
			this.$refs.detail.detailShow(row);
		},
		// 提成记录弹窗
		handleShowCommissionList(row, type) {
			this.$refs.commissionRecord.showCommissionReord(row, type);
		},
		// 导出
		handleExport() {
			this.$confirm("确定导出所选筛选条件查询出来的月工资信息吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
			exportWithLoading(this, "exportLoading", () => ExportUserMonthSalary(this.formInline), "导出失败，请稍后再试！").then(() => {
				this.loading = false;
			});
			});
		},
		// 确认
		handleConfirm(row) {
			this.$confirm("确定确认该月工资吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				ConfirmUserMonthBaseSalary({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "确认成功!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("确认失败，请稍后再试！");
					});
			});
		},
		// 更新员工月工资的提成
		handleUpdateBonus(row) {
			this.$confirm("确定更新该月工资的提成吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				UpdateUserMonthBonus({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "更新成功!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("更新失败，请稍后再试！");
					});
			});
		},
		// 更新员工月工资的基本工资信息
		handleUpdateBaseSalary(row) {
			this.$confirm("确定更新该月工资的基本工资吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				UpdateUserMonthBaseSalary({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "更新成功!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("更新失败，请稍后再试！");
					});
			});
		},
		// 删除
		handleDelete(row) {
			this.$confirm("确定删除该月工资吗?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				DeleteUserMonthSalary({
					keyId: row.keyId
				})
					.then((res) => {
						if (res.code === 1) {
							this.$message({
								type: "success",
								message: "删除成功!"
							});
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("删除失败，请稍后再试！");
					});
			});
		},

		// 批量生成月工资
		handleGenerate() {
			const defaultVal = this.formInline.year + "-" + (this.formInline.month < 10 ? "0" + this.formInline.month : this.formInline.month);
			this.$prompt("生成工资（在职且有基本工资的员工），格式 yyyy-MM", "生成月工资", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputValue: defaultVal,
				inputPattern: /^\d{4}-\d{1,2}$/,
				inputErrorMessage: "格式应为 yyyy-MM"
			}).then(({ value }) => {
				const arr = value.split("-");
				const year = parseInt(arr[0]);
				const month = parseInt(arr[1]);
				GenerateUserMonthSalary({ year: year, month: month })
					.then((res) => {
						if (res.code === 1 && res.data) {
							const d = res.data;
							this.$alert(
								"新增 " + d.generatedCount + " 条；跳过(无基本工资) " + d.skippedNoBaseSalaryCount + " 条；跳过(已存在) " + d.skippedExistsCount + " 条",
								"生成结果",
								{ confirmButtonText: "确定" }
							);
							this.getListData();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch(() => {
						this.$message.error("生成失败，请稍后再试！");
					});
				}).catch(() => {});
		},

		// 批量刷新当月月工资并重算实发金额（1=基本工资 2=提成）
		handleBatchRefresh(refreshType) {
			const label = refreshType === 1 ? "基本工资" : "提成";
			const monthStr = this.formInline.year + "年" + this.formInline.month + "月";
			this.$confirm("将按 " + monthStr + " 刷新当月所有未确认月工资的" + label + "信息并重新计算实发金额，已确认记录自动跳过，是否继续?", "批量刷新" + label, {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				BatchRefreshUserMonthSalary({ year: this.formInline.year, month: this.formInline.month, refreshType: refreshType })
					.then((res) => {
						if (res.code === 1 && res.data) {
							const d = res.data;
							this.$alert(
								"当月共 " + d.totalCount + " 条：刷新 " + d.refreshedCount + " 条；跳过(已确认) " + d.skippedConfirmedCount + " 条" +
								(refreshType === 1 ? "；跳过(无基本工资) " + d.skippedNoBaseSalaryCount + " 条" : ""),
								"刷新结果",
								{ confirmButtonText: "确定" }
							);
							this.getListData();
						} else {
							this.$message({ type: "info", message: res.msg });
						}
					})
					.catch(() => {
						this.$message.error("刷新失败，请稍后再试！");
					});
			}).catch(() => {});
		}
	}
};
</script>

<style scoped></style>
